module.exports = __webpack_public_path__ + "static/img/23.6cee885.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/23.png
// module id = t5kX
// module chunks = 0